import { Controller } from "@hotwired/stimulus"

// Drives the social-schedule modal form (#197 Phase 4): reveals each
// platform's customization fields when its checkbox is checked, and keeps the
// submit button disabled until at least one platform is selected. Replaces the
// legacy jQuery slideDown / formWideValidation behavior.
export default class extends Controller {
  static targets = ["platformCheckbox", "fields", "submit"]

  connect() {
    this.refresh()
  }

  toggle() {
    this.refresh()
  }

  refresh() {
    // Reveal each platform's fields when its checkbox is checked.
    this.platformCheckboxTargets.forEach((checkbox) => {
      const fields = this.fieldsTargets.find(
        (el) => el.dataset.platform === checkbox.dataset.platform
      )
      if (fields) fields.classList.toggle("hidden", !checkbox.checked)
    })

    // Disable submit until at least one platform is selected.
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.platformCheckboxTargets.some((c) => c.checked)
    }
  }
}
